import { types } from "./types/types";


const initialState = {
    formaPago: 0,
    email: '',
    loadingResponse: false,
    pagar: {
        idPago: 0,
        polizas: []
    },
    tarjetacredito: {
        name: '',
        focus: '',
        number: '',
        cvc: '',
        expiry: '',
        response: null,
        checkingResponse: true,
        // loadingResponse: false
    },
    yappy: {
        celular: '',
        response: null,
        checkingResponse: true,
        // loadingResponse: false
    },
    clave:{
        redirectUrl: null,
        checkingResponse: true,
    }
}

export const pago = (state = initialState, action) => {
    switch (action.type) {
        case types.setIdPago:
            return {
                ...state,
                pagar: {
                    ...state.pagar,
                    idPago: action.payload
                }
            }
        case types.setAllPagarPoliza:
            return {
                ...state,
                pagar: {
                    ...state.pagar,
                    polizas: action.payload
                }
            }
        case types.setCheckAllPagarPoliza:
            return {
                ...state,
                pagar: {
                    ...state.pagar,
                    polizas: [...state.pagar.polizas.map(value => ({
                        ...value,
                        CHECK: true
                    }))]
                }
            }
        case types.setCheckPagarPoliza:
            return {
                ...state,
                pagar: {
                    ...state.pagar,
                    polizas: [...state.pagar.polizas.map(value => ({
                        ...value,
                        CHECK: value.ID === action.payload ? true : value.CHECK
                    }))]
                }
            }
        case types.removeAllPagarPoliza:
            return {
                ...state,
                pagar: {
                    ...state.pagar,
                    polizas: []
                }
            }
        case types.removeCheckAllPagarPoliza:
            return {
                ...state,
                pagar: {
                    ...state.pagar,
                    polizas: [...state.pagar.polizas.map(value => ({
                        ...value,
                        CHECK: false
                    }))]
                }
            }
        case types.removeCheckPagarPoliza:
            return {
                ...state,
                pagar: {
                    ...state.pagar,
                    polizas: [...state.pagar.polizas.map(value => ({
                        ...value,
                        CHECK: value.ID === action.payload ? false : value.CHECK
                    }))]
                }
            }
        // change cambio de pago
        case types.setChangePago:
            return {
                ...state,
                pagar: {
                    ...state.pagar,
                    polizas: [...state.pagar.polizas.map(value => ({
                        ...value,
                        PAGAR: value.ID === action.payload.id ? action.payload.pago : value.PAGAR
                    }))]
                }
            }
        // email
        case types.setHandleChangeEmail:
            return {
                ...state,
                email: action.payload
            }
        // Forma de pago
        case types.setFormaPago:
            return {
                ...state,
                formaPago: action.payload
            }
        // loading de proceso de pago
        case types.startloadingResponseProcesoPago:
            return {
                ...state,
                loadingResponse:true
            }
        case types.finishloadingResponseProcesoPago:
            return {
                ...state,
                loadingResponse:false
            }
        // ? TARJETA DE CREDITOS
        //* handle change tarjeta de credito
        case types.setChangeTarjetaCredito:
            return {
                ...state,
                tarjetacredito: {
                    ...state.tarjetacredito,
                    [action.payload.name]: action.payload.value
                }
            }
        // respuesta de tarjeta de credito
        case types.setResponseTarjetaCredito:
            return {
                ...state,
                tarjetacredito: {
                    ...state.tarjetacredito,
                    response: action.payload,
                    checkingResponse: false
                }
            }
        case types.setResponseClave:
            return {
                ...state,
                clave: {
                    ...state.clave,
                    response: action.payload,
                    checkingResponse: false
                }
            }

        // Loading de tarjeta de credito
        // case types.startloadingResponseTarjetaCredito:
        //     return {
        //         ...state,
        //         tarjetacredito: {
        //             ...state.tarjetacredito,
        //             loadingResponse: true
        //         }
        //     }
        // case types.finishloadingResponseTarjetaCredito:
        //     return {
        //         ...state,
        //         tarjetacredito: {
        //             ...state.tarjetacredito,
        //             loadingResponse: false
        //         }
        //     }

        // ? YAPPY
        // *handle change tarjeta de credito
        case types.setHandleChangeYappy:
            return {
                ...state,
                yappy: {
                    ...state.yappy,
                    [action.payload.name]: action.payload.value
                }
            }
        //* Loading de response yappy url
        // case types.startloadingResponseYappy:
        //     return {
        //         ...state,
        //         yappy: {
        //             ...state.yappy,
        //             loadingResponse: true
        //         }
        //     }
        // case types.finishloadingResponseYappy:
        //     return {
        //         ...state,
        //         yappy: {
        //             ...state.yappy,
        //             loadingResponse: false
        //         }
        //     }
        default:
            return state;
    }
}